import "./ErrorBoundary.scss";

import type { ReactNode } from "react";

import { ErrorFallbackLabel } from "../../types/enums/labels";
import { Button } from "../shared/Button";

export interface ErrorFallbackProps {
  /** The caught error (optional message/detail shown) */
  error: Error | null;
  /** Callback to reset error state and re-render the child tree */
  reset: () => void;
  /** Optional custom content instead of default title/description */
  children?: ReactNode;
}

/**
 * Fallback UI when an error boundary catches an error.
 * Shows a message and a "Try again" button that calls reset().
 */
export function ErrorFallback({ error, reset, children }: ErrorFallbackProps) {
  return (
    <div className="error-fallback" role="alert">
      <div className="error-fallback__card">
        {children ?? (
          <>
            <h1 className="error-fallback__title">{ErrorFallbackLabel.Title}</h1>
            <p className="error-fallback__description">{ErrorFallbackLabel.Description}</p>
            {error?.message && (
              <pre className="error-fallback__detail" aria-live="polite">
                {error.message}
              </pre>
            )}
            <Button variant="primary" onClick={reset}>
              {ErrorFallbackLabel.TryAgain}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
